import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LucideAngularModule, Star, Clock, Tag } from 'lucide-angular';
import { Restaurant } from '../../data/mock';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-restaurant-card',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './restaurant-card.component.html',
  styleUrl: './restaurant-card.component.css'
})
export class RestaurantCardComponent {

  @Input() restaurant!: Restaurant;
  timestamp = Date.now();
  @Input() disabled: boolean = false;
  @Input() aggregatorSetup: any;  // 👈 ADD THIS

  constructor(
    private router: Router,
    private toastService: ToastService
  ) { }

  goToRestaurant() {
    // if (this.disabled) {
    //   this.toastService.showErrorToast('Location permission denied. Please allow location access in your browser settings.');
    //   return; // ❌ block click
    // }
    this.restaurant.id
    this.router.navigate(['/restaurant', this.restaurant.id]);
  }

  // redirectToPartner(restaurantId: number, type: string) {
  //   if (this.disabled) {
  //     this.toastService.showErrorToast('Location permission denied. Please allow location access in your browser settings.');
  //     return; // ❌ block click
  //   }
  //   // Step 1: Get data for this restaurant
  //   const restaurantData = this.aggregatorSetup?.[restaurantId];

  //   if (!restaurantData) {
  //     return;
  //   }

  //   // Step 2: Find aggregator
  //   // const partner = restaurantData.aggregatorRestaurantSetUp.find(a =>
  //   //   a?.aggregatorType?.toUpperCase() === type.toUpperCase()
  //   // );
  //   const partner = restaurantData?.aggregatorRestaurantSetUp?.find(
  //     (a: any) =>
  //       a?.aggregatorType?.toUpperCase() === type.toUpperCase()
  //   );

  //   // // Step 3: Redirect
  //   if (partner?.restaurantUrl) {
  //     window.open(partner.restaurantUrl, '_blank');
  //   } else {
  //     // console.warn('No matching aggregator found');
  //     this.toastService.showErrorToast("No aggregator found");
  //   }
  // }

  redirectToPartner(restaurantId: number, type: string) {
    if (!this.aggregatorSetup?.length) {
      this.toastService.showErrorToast('No aggregator found');
      return;
    }

    const partner = this.aggregatorSetup.find(
      (item: any) =>
        item.restaurantRefNo === restaurantId &&
        item.aggregator?.toUpperCase() === type.toUpperCase()
    );

    if (partner?.restaurantUrl) {
      window.open(partner.restaurantUrl, '_blank');
    } else {
      this.toastService.showErrorToast(`No ${type} link found`);
    }
  }
}